<template>
  <BaseGlobalLoader v-if="isLoaded"/>
  <router-view v-else/>
  <component is="script" :src="MEET_BASE_API_URL" async></component>
</template>


<script setup>
import 'nprogress/nprogress.css'
import '../public/assets/css/nprogress.custom.css'
import BaseGlobalLoader from '@/components/BaseGlobalLoader'
import {computed, nextTick, onMounted, watch} from 'vue';
import {useStore} from "vuex";
import {getImagePath, getTenantId} from './mixins/Helpers';
import { useRoute } from 'vue-router';
import {MEET_BASE_API_URL} from "@/services/meetService";
import Ls from "@/services/ls";
const store = useStore()
const isLoaded = computed(()=> store.getters['isAppLoaded'])

const route = useRoute();

const updateMeta = async () => {
  const tenantId = getTenantId()?.slice(0, -1);

  document.title = `${tenantId?.toUpperCase() || "BY+"}`;
  const favicon = document.querySelector("link[rel='icon']") || document.createElement("link");
  favicon.rel = "icon";
  getImagePath('favicon.png').then((path) => favicon.href=path );
  document.head.appendChild(favicon);


};

const loadTenantIcon = async () => {
  const tenantId = getTenantId()?.slice(0, -1);
  const iconHref = `/assets/media/${tenantId}/pwa-192x192.png`;
  const iconFallbackHref = `/pwa-192x192.png`;

  try {
    const res = await fetch(iconHref, { method: 'HEAD' });

    const appleIcon = document.querySelector("link[rel='apple-touch-icon']") || document.createElement('link');
    appleIcon.rel = 'apple-touch-icon';
    appleIcon.href = iconHref;

      if (!appleIcon.parentNode) {
        document.head.appendChild(appleIcon);
      }
  } catch (error) {
    appleIcon.rel = 'apple-touch-icon';
    appleIcon.href = iconFallbackHref;
    document.head.appendChild(appleIcon);
  }
};

const loadTenantManifest = async () => {
  const manifestHref = `/manifests/${getTenantId()}manifest.json`;
  const fallbackHref = '/manifests/manifest.json';
 
  try {
    const res = await fetch(manifestHref, { method: 'HEAD' });

    const manifestLink = document.querySelector("link[rel='manifest']") || document.createElement('link');
    manifestLink.rel = 'manifest';
    manifestLink.href = res.ok ? manifestHref : fallbackHref;

    if (!manifestLink.parentNode) {
      document.head.appendChild(manifestLink);
    }
  } catch (error) {
    manifestLink.rel = 'manifest';
    manifestLink.href = fallbackHref;
    document.head.appendChild(manifestLink);
  }
};

onMounted(() => {
  nextTick(() => {
    updateMeta()
    loadTenantManifest()
    loadTenantIcon()
  })
  Ls.set('pageLength', 10)
});

watch(route, () => {
  updateMeta()
  loadTenantManifest()
});

</script>
<style scoped>
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.scroll-y {
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}


</style>
